<template>
  <div style="background: #1f1c1f;">
    <div class="header">
      <div class="header_content">
        <div class="img">
          <img src="/img/clogo.png" alt="" /> {{$t("index.club_name")}}
        </div>
        <div v-if="!hasToken" @click="toLogin('/Register')">{{$t("auth.register")}}</div>
        <div v-else></div>
      </div>
    </div>
    <div style="height: 160px;">
      <swiper class="banner_swiper" :options="bannerSwiperOption">
        <swiper-slide v-for="(v,key) in banners" :key="key">
          <van-image class="banner_img" :src="`https://admin.fyxoriapay.com${v.url}`" width="100%" height="160px">
            <template v-slot:loading>
              <van-loading type="circular"/>
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
    </div>
    <div style="padding: 10px;">
      <van-notice-bar
        class="notice-swiper"
        color="#f3c7a2"
        background="#313131"
        scrollable
        :text="this.notice"
      >
        <template #left-icon>
          <img
            src="/img/neww/notice.png"
            alt="Custom Icon"
            style="width: 15px; height: 15px; margin-right: 10px;"
          />
        </template>
      </van-notice-bar>
    </div>
    <div class="nav_box">
      <div class="x_p" @click="toLogin('/Video')">
        <img src="/img/neww/ico_video.png" alt="" />
        <div class="text_c">{{$t("q39")}}</div>
      </div>
      <div class="x_p" @click="toLogin('/Choose')">
        <img src="/img/neww/ico_vip.png" alt="" />
        <div class="text_c">{{$t("q40")}}</div>
      </div>
    </div>
    <div class="wuzii" @click="toLogin('/Choose')">
      <div class="put_tit">{{$t("q41")}}：</div>
      <div class="xx_bc">
        <div class="top_link">{{$t("q42")}}</div>
        <div class="top_link">{{$t("q421")}}</div>
        <div class="top_link">{{$t("q422")}}</div>
        <div class="top_link">{{$t("q423")}}</div>
        <div class="top_link">{{$t("q424")}}</div>
        <div class="top_link">{{$t("q425")}}</div>
        <div class="top_link">{{$t("q426")}}</div>
        <div class="top_link">{{$t("q427")}}</div>
        <div class="top_link">{{$t("q428")}}</div>
        <div class="top_link">{{$t("q429")}}</div>
        <div class="top_link">{{$t("q430")}}</div>
        <div class="top_link">{{$t("q431")}}</div>
        <div class="top_link">{{$t("q432")}}</div>
        <div class="top_link">{{$t("q433")}}</div>
        <div class="top_link">{{$t("q434")}}</div>
        <div class="top_link">{{$t("q435")}}</div>
        <div class="top_link">{{$t("q436")}}</div>
        <div class="top_link">{{$t("q437")}}</div>
        <div class="top_link">{{$t("q438")}}</div>
        <div class="top_link">{{$t("q439")}}</div>
        <div class="top_link">{{$t("q440")}}</div>
        <div class="top_link">{{$t("q441")}}</div>
        <div class="top_link">{{$t("q442")}}</div>
        <div class="top_link">{{$t("q443")}}</div>
        <div class="top_link">{{$t("q444")}}</div>
        <div class="top_link">{{$t("q445")}}</div>
        <div class="top_link">{{$t("q446")}}</div>
        <div class="top_link">{{$t("q447")}}</div>
        <div class="top_link">{{$t("q448")}}</div>
        <div class="top_link">{{$t("q449")}}</div>
        <div class="top_link">{{$t("q450")}}</div>
        <div class="top_link">{{$t("q451")}}</div>
        <div class="top_link">{{$t("q452")}}</div>
        <div class="top_link">{{$t("q453")}}</div>
        <div class="top_link">{{$t("q454")}}</div>
        <div class="top_link">{{$t("q455")}}</div>
        <div class="top_link">{{$t("q456")}}</div>
        <div class="top_link">{{$t("q457")}}</div>
        <div class="top_link">{{$t("q458")}}</div>
        <div class="top_link">{{$t("q459")}}</div>
        <div class="top_link">{{$t("q460")}}</div>
        <div class="top_link">{{$t("q43")}}</div>
        <div class="top_link">{{$t("q44")}}</div>
        <div class="top_link">{{$t("q45")}}</div>
        <div class="top_link">{{$t("q46")}}</div>
        <div class="top_link">{{$t("q47")}}</div>
        <div class="top_link">{{$t("q48")}}</div>
        <div class="top_link">{{$t("q49")}}</div>
        <div class="top_link">{{$t("q50")}}</div>
        <div class="top_link">{{$t("q51")}}</div>
      </div>
    </div>
    <div class="wuzii_p">
      <div class="put_tit">{{$t("q52")}}</div>
      <div class="xx_bc_u" @click="toLogin('/Choose')">
        {{$t("q53")}}
      </div>
    </div>
    <div class="tu_list">
      <div class="tu_item" v-for="item in datalist" :key="item.id" @click="toDetail(item.id)">
        <div class="renzh">{{$t("q54")}}</div>
        <div class="info_box">
          <div class="c_id">{{ item.xuanfei_name }}</div>
          <div class="c_c">{{$t("index.height")}}: {{item.hight}}cm</div>
          <div class="c_c">{{$t("index.bust")}}：{{ item.bust }}</div>
          <div class="c_c">{{$t("index.address")}}： </div>
          <div class="c_b_k">
            <img src="/img/neww/icon_views.png" class="sm_in">
            <span>{{item.chakan}}</span>
            <img src="/img/neww/icon_love.png" class="sm_in cc">
            <span>{{item.dianzan}}</span>
          </div>
        </div>
        <img :src="`${item.img_url}`" class="sm_in_c van-image__img" style="object-fit: cover;">
      </div>
    </div>
    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      translateY: -18,
      containerHeight: 0,
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      banners: [{}],
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      tagTypes: ['primary', 'success', 'danger', 'warning']
    };
  },

  methods: {
    getBasicConfig() {
      this.$http({ method: "get", url: "sys_config" }).then((res) => {
        console.log('完整notice结构:', JSON.stringify(res.data.notice))
        this.basicData = res.data
        this.getNotice(this.basicData)
        this.getBanner(this.basicData)
      })
    },

    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        console.log(res, 11);
      });
    },

    getBanner(data) {
      this.banners = data.banners;
    },

    toLogin(str) {
      this.$router.push({ path: str });
    },

    // ✅ 修复：根据当前语言取对应公告
    getNotice(data) {
      const lang = localStorage.getItem('lang') || 'en';

      if (!data.notice) {
        this.notice = '';
        return;
      }

      // 如果是对象（多语言结构）：{ zh: '...', en: '...', ja: '...' }
      if (typeof data.notice === 'object') {
        this.notice = data.notice[lang] || data.notice['en'] || data.notice['en'] || '';
        return;
      }

      // 如果是用 | 分隔的字符串："中文|English|日本語"
      if (typeof data.notice === 'string') {
        const parts = data.notice.split('|');
        if (parts.length > 1) {
          const langMap = { zh: 0, en: 1, ja: 2 };
          const idx = langMap[lang] ?? 1;
          this.notice = parts[idx] || parts[0];
        } else {
          this.notice = data.notice;
        }
      }
    },

    startAnimation() {
      const interval = setInterval(() => {
        this.translateY -= 18;
        if (this.translateY <= -this.containerHeight) {
          this.translateY = 0;
        }
      }, 1000);

      this.$once("hook:beforeDestroy", () => {
        clearInterval(interval);
      });
    },

    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },

    checkToken() {
      const token = localStorage.getItem("token");
      this.hasToken = !!token;
      this.$nextTick(() => {
        console.log("View updated:", this.hasToken);
      });
    },

    // ✅ 修复：item.flag 可能为 undefined
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: 1 },
      }).then((res) => {
        const lang = localStorage.getItem("lang");
        this.datalist = res.data;
        this.datalist.forEach(item => {
          if (item.flag) {
            const parts = item.flag.split('|');
            lang == 'zh' ? item.flag = parts[0]
              : lang == 'en' ? item.flag = parts[1]
              : lang == 'ja' ? item.flag = parts[2]
              : item.flag = parts[3];
            item.flagArray = item.flag ? item.flag.split('，') : [];
          } else {
            item.flagArray = [];
          }
        });
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
      });
    },
  },

  // ✅ 修复：scrollContainer ref 已不存在，加判断避免报错
  mounted() {
    if (this.$refs.scrollContainer) {
      this.containerHeight = this.$refs.scrollContainer.clientHeight;
      this.startAnimation();
    }
  },

  created() {
    this.checkToken()
    this.getBasicConfig()
    this.getxuanfeilist()
    this.getHotLottery()
  },
};
</script>

<style lang="less" scoped>
.tu_list {
  .tu_item {
    margin: 26px 20px 16px;
    border-radius: 16px;
    padding: 30px 40px 30px 26px;
    background: linear-gradient(120deg, #212121, #313131);
    border: 1px solid #766350;
    display: flex;
    justify-content: space-between;
    position: relative;
    overflow: hidden;

    .renzh {
      position: absolute;
      right: -72px;
      top: 32px;
      font-size: 24px;
      padding: 1px 59px;
      font-style: normal;
      transform: rotate(45deg);
      background: linear-gradient(90deg, #efcba7, #dcab76);
      color: #000000;
    }

    .sm_in_c {
      width: 186px;
      height: 186px;
      border-radius: 50%;
    }

    .info_box {
      .c_id {
        width: 200px;
        text-align: center;
        background-color: #fff;
        background: linear-gradient(90deg, #efcba7, #dcab76);
        color: #8d5825;
        border-radius: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .c_c {
        color: #ddd;
        font-size: 26px;
        padding-top: 10px;
      }

      .c_b_k {
        display: flex;
        align-items: center;
        color: #666;
        font-size: 22px;
        padding-top: 16px;

        .sm_in {
          width: 30px;
          height: 30px;

          &.cc {
            margin-left: 16px;
          }
        }
      }
    }
  }
}

.nav_box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #766350;
  margin: 10px 20px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg, #212121, #313131);

  .x_p {
    text-align: center;
    color: #e6b98a;
    flex: 1;

    img {
      height: 76px;
    }
  }
}

.put_tit {
  font-weight: bold;
  color: #e6b98a;
  font-size: 28px;
  padding-left: 16px;
  position: relative;

  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 30px;
    background-color: #e6b98a;
    left: 0;
    top: 6px;
  }
}

.wuzii {
  margin: 26px 20px 16px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;

  .xx_bc {
    display: flex;
    flex-wrap: wrap;
    font-size: 26px;
    color: #ccc;
    padding-top: 10px;
    justify-content: space-between;

    .top_link {
      padding: 20px 20px;
    }
  }
}

.wuzii_p {
  margin: 26px 20px 16px;
  background: linear-gradient(120deg, #212121, #313131);
  display: flex;
  padding: 20px 20px;
  justify-content: space-between;

  .xx_bc_u {
    color: #ccc;
  }
}

.header {
  height: 13vw;
}

.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;

  .img {
    height: 80px;
    display: inline-flex;
    align-items: center;

    img {
      width: auto;
      height: 100%;
      margin-right: 10px;
    }
  }
}

.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 16px;
  border: 1px solid #766350;
}

.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}

.gdgride {
  padding-right: 40px;
}

.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}

.gdgride span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  font-size: 3vw;
  top: -11vw;
  right: -11vw;
}

.gdgride span i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
}

.van-image {
  position: relative;
  display: inline-block;
}

.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}

.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}

.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}

.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}

.top {
  display: flex;
}

.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}

.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}

.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}

.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}

.OnlineMatching {
  height: 28vw;
  overflow: hidden;
}

.OnlineMatching ul li {
  text-align: center;
  color: #fff;
  font-size: 4vw;
  margin-top: 20px;
}
</style>